import Header from "../components/Authentication/Header";
import SignUp from "../components/Authentication/SignUp";

const SignUpPage = () => {
  return (
    <>
      <Header title="Create your account" />
      <SignUp />
    </>
  );
};

export default SignUpPage;
